module.exports = __webpack_public_path__ + "img/1452118957.c129a4f0.jpg";